/* fakturownia application js v7.0 */

import "../controllers"
import Rails from "@rails/ujs"
Rails.start()
